///<reference path="../../definitions/weather.d.ts"/>
///<reference path="../util/SDTDate.ts"/>
///<reference path="../Const.ts"/>

namespace app.model{
	import SDTDate = app.util.SDTDate;
	export class Sunrise{
		data:SunriseData[] = [];

		public parseData(json:SunriseJSON, location:string){
			// console.log(json);
			let data:SunriseJSON = json[location];
			data.sun.forEach((elm) => {
				this.data.push({
					day:new SDTDate(elm.day, Const.DATE_CHOSEKI),
					sunrise:elm.sunrise,
					sunset:elm.sunset
				});
			});
			// console.log(this.items);
		}
	}
}